import { gql } from '@apollo/client'

export const SABRE_UPDATE_CATEGORY = gql`
  mutation UpdateCategory($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      category {
        id
        name
        parent {
          id
          name
        }
      }
    }
  }
`
